import React, { useState } from "react";
import { createMatchesFromTeams } from "services/matchService";
import * as Sentry from "@sentry/react";

const CreateMatchesButton = ({ tournament, onCreated }) => {
  const [goalsToWin, setGoalsToWin] = useState(1);
  const [showConfig, setShowConfig] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (!tournament || !tournament.teams || Object.keys(tournament.teams).length === 0) {
      alert("Tournoi ou équipes non valides.");
      return;
    }

    setIsLoading(true);
    try {
      await createMatchesFromTeams({ ...tournament, goalsToWin });
      onCreated?.(); // optional callback
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur lors de la création des matchs :", error);
      alert("❌ Une erreur est survenue lors de la création des matchs.");
    } finally {
      setIsLoading(false);
    }
  };

  if (showConfig) {
    return (
      <div className="bg-slate-800 p-4 rounded-lg border border-slate-700">
        <h4 className="text-slate-50 font-bold mb-3">Configuration des matchs de qualification</h4>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <label className="text-slate-50 text-sm">Buts pour gagner:</label>
            <input
              type="number"
              min="1"
              max="10"
              value={goalsToWin}
              onChange={(e) => setGoalsToWin(parseInt(e.target.value) || 1)}
              className="bg-slate-800 text-slate-50 px-2 py-1 rounded border border-slate-700 w-16"
            />
            <span className="text-slate-300 text-xs">(1 = match simple 0-1)</span>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleClick}
              disabled={isLoading}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed font-bold"
            >
              {isLoading ? "Création en cours..." : "Créer les matchs"}
            </button>
            <button
              onClick={() => setShowConfig(false)}
              disabled={isLoading}
              className="px-4 py-2 bg-slate-700 text-slate-50 rounded hover:bg-slate-800/50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={() => setShowConfig(true)}
      className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 font-bold"
    >
      Créer les matchs
    </button>
  );
};

export default CreateMatchesButton;
